import { render, staticRenderFns } from "./RemoveBidModal.vue?vue&type=template&id=b8d7f64a"
import script from "./RemoveBidModal.vue?vue&type=script&lang=js"
export * from "./RemoveBidModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports